$(function() {
    if ($('.js-file-upload').length > 0) {
        $('.js-file-upload input').addClass('js-hidden-file-input');
        //$('.js-file-upload input').attr('type', 'file');
        $('<input type="file" class="js-form-file-upload" name="cf_file" accept=".jpg, .jpeg, .png, .docx, .doc, .pdf, .xlsx, .xls, .csv" />').insertBefore('.js-file-upload input');

        $(document).on('change', '.js-form-file-upload', function() {
            var that = $(this);
            if($(this).prop('files').length > 0)
            {
                var data = new FormData();
                data.append( "file" , $(this).prop('files')[0] );
            }
            var url = window.location.origin + "/ajax/file.attachment.php";
            $.ajax({
                url: url,
                type: 'POST',
                data: data,
                cache: false,
                dataType: 'json',
                processData: false,
                contentType: false, 
                success: function (result) {
                    if (result.result == false) return;
                    $(document).find(that).parent().find('.js-hidden-file-input').val(result.result);
                }
            });
        });
    }


    $('.wpforms-submit').on('click', function(){

        var interval = setInterval(updateUploadRequiredError, 100);

        function updateUploadRequiredError() {
            $('.js-form-file-upload').each(function(){
                // if($(this).hasClass('wpforms-valid')){
                if ($(this).get(0).files.length > 0) {
                    $(this).siblings('.wpforms-error').css('display', 'none');
                }
            });
        }
    });
});

